import { configSettings } from '@/lib/config';
import { mainApi } from '../index';
import { CommunitiesResponse } from './types';

export const fetchCommunities = async (): Promise<CommunitiesResponse> => {
    const { data } = await mainApi.get<CommunitiesResponse>('/v1/communities/owned', {
        baseURL: configSettings.communityApiUrl,
        params: {
            with_messages: false,
        },
    });
    return data;
};
